import React from 'react'
import FormCarousel from '../../Components/FormCarousel'

const AjouterCarousel = () => {
  return <FormCarousel />
}

export default AjouterCarousel
